import Vue from 'vue'
import VueRouter from 'vue-router'
import TokenService from '../services/storage.service'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'

import TaskListing from '../views/Tasks/Listing.vue'
import TaskNew from '../views/Tasks/New.vue'
import TaskEdit from '../views/Tasks/Single.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Login,
    meta: {
      public: true,  // Allow access to guest user.
      onlyWhenLoggedOut: true
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Profile Settings',
      key: 'user_profile'
    }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: TaskListing,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Tasks',
      key: 'tasks_listing'
    }
  },
  {
    path: '/tasks',
    name: 'Task Listing',
    component: TaskListing,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Tasks',
      key: 'tasks_listing'
    }
  },
  {
    path: '/task/add',
    name: 'New Task',
    component: TaskNew,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Add Task',
      key: 'task_add'
    }
  },
  {
    path: '/task/edit/:id',
    name: 'Edit Task',
    component: TaskEdit,
    props: true,
    meta: {
      public: false,  // Allow access to only loggedin user.
      title: 'Edit Task',
      key: 'tasks_edit'
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/dashboard')
  }
  next();
}) 

export default router